import VISA_ICON from "./../styles/images/visa.png";
import AMERICAN_EXPRESS_ICON from "./../styles/images/amex.png";
import MASTER_CARD_ICON from "./../styles/images/masterCard.png";
import DISCOVER_ICON from "./../styles/images/discover.png";
import DINERS_CLUB_ICON from "./../styles/images/diners.png";
import JCB_ICON from "./../styles/images/JCB.png";

export const apiGetAddressApiKey = "CluVSMJ-yUK83VAsuUMNrA748";

export const searchByDate = [
    {value:"",label:"Created Date"},
    {value:1,label:"Today"},
    {value:2,label:"Yesterday"},
    {value:3,label:"This Week"},
    {value:4,label:"Last Week"},
    {value:5,label:"This Month"},
    {value:6,label:"Last Month"},
    {value:7,label:"Last 3 Months"},
    {value:8,label:"Last 6 Months"},
    {value:9,label:"This Year"},
    {value:10,label:"Last Year"},
];

export const searchLastActivityDate = [
    {value:"",label:"Last Activity Date"},
    {value:1,label:"Today"},
    {value:2,label:"Yesterday"},
    {value:3,label:"This Week"},
    {value:4,label:"Last Week"},
    {value:5,label:"This Month"},
    {value:6,label:"Last Month"},
    {value:7,label:"Last 3 Months"},
    {value:8,label:"Last 6 Months"},
    {value:9,label:"This Year"},
    {value:10,label:"Last Year"},
];

export const searchByContactStatus = [
    {value:"",label:"Lead Status"},
    {value:1,label:"New"},
    {value:2,label:"Open"},
    {value:3,label:"In Progress"},
    {value:4,label:"Assigned"},
    {value:5,label:"Un Assigned"},
];

export const viewSharedWith = [
    {value:1,label:"Private"},
    {value:2,label:"My Teams"},
    {value:3,label:"Every One"},
];

export const viewType = [
    {value:1,label:"Standared"},
    {value:2,label:"Created by me"},
    {value:3,label:"Created by others"},
];

export const OTHERCARDS = [
    /[1-9]/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ];
  export const AMERICANEXPRESS = [
    /[1-9]/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ];
  export const EXPIRYDATE = [/[0-9]/, /\d/, "/", /\d/, /\d/];
  export const CVC = [/[0-9]/, /\d/, /\d/, /\d/];

  export const CARDICON = {
    VISA: VISA_ICON,
    MASTERCARD: MASTER_CARD_ICON,
    DISCOVER: DISCOVER_ICON,
    AMERICAN_EXPRESS: AMERICAN_EXPRESS_ICON,
    DINERS_CLUB: DINERS_CLUB_ICON,
    JCB: JCB_ICON
  };

  export const CARDARR = [
    "VISA",
    "MASTERCARD",
    "AMERICAN_EXPRESS",
    "DISCOVER",
    "DINERS_CLUB",
    "JCB"
  ];

  export const COLORARR = [
    ["#20bdff", "#5433ff"],
    ["#ff4b1f", "#ff9068"],
    ["#ffb347", "#ffcc33"],
    ["#D38312", "#A83279"],
    ["#83a4d4", "#b6fbff"],
    ["#fbd3e9", "#bb377d"]
  ];

  export let API_PAYMENT_CONFIG = {
    sitecode: "UFUK",
    appcode: "UFGBP",
    productcode: "BILL-UR",
    paymentagent: "UFUK",
    servicetype: "RES",
    paymentmode: "DEF",
    site_currency: "GBP",
    payment_country: "United Kingdom,UK",
    euro_currency_code: '&#163;',
    uk_currency_code: '&#163;',
    usa_currency_code: '&#36;',
    euro_currency: 'EUR',
    uk_currency: 'GBP',
    usa_currency: 'USD',
    intl_phone_number_charge: '9.99',
    domestic_phone_number_charge: '2.00',
    userphonecharge: '12.99',
    localnumbercharge: '2.00',
    mobilenumbercharge: '5.00',
    adduseronly_charge: '1.00',
    vatperchantagecharge: '20',
    deliverycharge: '15',
    phonenumbercharge: '2.00',
    product: 'DSK',
    accountid: 'UR-'
  };

  export const user_type_new = [
    { id: '1', value: 'Basic' },
    { id: '2', value: 'Standard' },
    { id: '3', value: 'Pro' },
  ];

  export const user_type_price = {
    Standard: 5.00,
    Basic: 2.00,
  }

  export const device_price = {
    shipping_charge : 5.50
  }
export const timeoption = [
    { value: '00:00', label: '12:00' },
    { value: '00:30', label: '12:30' },
    { value: '01:00', label: '01:00' },
    { value: '01:30', label: '01:30' },
    { value: '02:00', label: '02:00' },
    { value: '02:30', label: '02:30' },
    { value: '03:00', label: '03:00' },
    { value: '03:30', label: '03:30' },
    { value: '04:00', label: '04:00' },
    { value: '04:30', label: '04:30' },
    { value: '05:00', label: '05:00' },
    { value: '05:30', label: '05:30' },
    { value: '06:00', label: '06:00' },
    { value: '06:30', label: '06:30' },
    { value: '07:00', label: '07:00' },
    { value: '07:30', label: '07:30' },
    { value: '08:00', label: '08:00' },
    { value: '08:30', label: '08:30' },
    { value: '09:00', label: '09:00' },
    { value: '09:30', label: '09:30' },
    { value: '10:00', label: '10:00' },
    { value: '10:30', label: '10:30' },
    { value: '11:00', label: '11:00' },
    { value: '11:30', label: '11:30' },
    { value: '11:59', label: '11:59' },
    //{ value: '12:00', label: '12:00' }
  ];

export const timeslot = [
    { value: 'AM', label: 'AM' },
    { value: 'PM', label: 'PM' }
  ];
  export const timeZoneId = [
    { value: "62", label: "(GMT-12:00) International Date Line West" },
    { value: "61", label: "(GMT-11:00) Midway Island, Samoa" },
    { value: "60", label: "(GMT-10:00) Hawaii" },
    { value: "59", label: "(GMT-09:00) Alaska" },
    { value: "58", label: "(GMT-08:00) Pacific Time (US & Canada)" },
    { value: "63", label: "(GMT-08:00) Tijuana, Baja California" },
    { value: "56", label: "(GMT-07:00) Arizona" },
    { value: "64", label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan" },
    { value: "57", label: "(GMT-07:00) Mountain Time (US & Canada)" },
    { value: "65", label: "(GMT-06:00) Central America" },
    { value: "53", label: "(GMT-06:00) Central Time (US & Canada)" },
    { value: "54", label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey" },
    { value: "55", label: "(GMT-06:00) Saskatchewan" },
    { value: "50", label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco" },
    { value: "51", label: "(GMT-05:00) Eastern Time (US & Canada)" },
    { value: "52", label: "(GMT-05:00) Indiana (East)" },
    { value: "48", label: "(GMT-04:00) Atlantic Time (Canada)" },
    { value: "66", label: "(GMT-04:30) Caracas" },
    { value: "49", label: "(GMT-04:00) La Paz" },
    { value: "67", label: "(GMT-04:00) Manaus" },
    { value: "68", label: "(GMT-04:00) Santiago" },
    { value: "47", label: "(GMT-03:30) Newfoundland" },
    { value: "45", label: "(GMT-03:00) Brasilia" },
    { value: "69", label: "(GMT-03:00) Buenos Aires" },
    { value: "46", label: "(GMT-03:00) Georgetown" },
    { value: "70", label: "(GMT-03:00) Greenland" },
    { value: "71", label: "(GMT-03:00) Montevideo" },
    { value: "44", label: "(GMT-02:00) Fernando de Noronha" },
    { value: "43", label: "(GMT-01:00) Azores" },
    { value: "72", label: "(GMT-01:00) Cape Verde Is." },
    { value: "1", label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik" },
    { value: "2", label: "(GMT+00:00) Dublin, Edinburgh, Lisbon, London" },
    { value: "6", label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
    { value: "5", label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague" },
    { value: "3", label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris" },
    { value: "4", label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb" },
    { value: "73", label: "(GMT+01:00) West Central Africa" },
    { value: "74", label: "(GMT+02:00) Amman" },
    { value: "7", label: "(GMT+02:00) Athens, Bucharest, Istanbul" },
    { value: "75", label: "(GMT+02:00) Beirut" },
    { value: "9", label: "(GMT+02:00) Cairo" },
    { value: "88", label: "(GMT+02:00) Damascus" },
    { value: "89", label: "(GMT+02:00) Gaza" },
    { value: "10", label: "(GMT+02:00) Harare, Pretoria" },
    { value: "11", label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius" },
    { value: "12", label: "(GMT+02:00) Jerusalem" },
    { value: "8", label: "(GMT+02:00) Minsk" },
    { value: "78", label: "(GMT+02:00) Windhoek" },
    { value: "79", label: "(GMT+03:00) Baghdad" },
    { value: "13", label: "(GMT+03:00) Kuwait, Riyadh" },
    { value: "14", label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd" },
    { value: "15", label: "(GMT+03:00) Nairobi" },
    { value: "16", label: "(GMT+03:30) Tehran" },
    { value: "17", label: "(GMT+04:00) Abu Dhabi, Muscat" },
    { value: "81", label: "(GMT+04:00) Baku" },
    { value: "80", label: "(GMT+04:00) Tbilisi" },
    { value: "18", label: "(GMT+04:00) Yerevan" },
    { value: "19", label: "(GMT+04:30) Kabul" },
    { value: "20", label: "(GMT+05:00) Ekaterinburg" },
    { value: "21", label: "(GMT+05:00) Islamabad, Karachi, Tashkent" },
    { value: "22", label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi" },
    { value: "24", label: "(GMT+05:30) Sri Jayawardenepura" },
    { value: "82", label: "(GMT+05:45) Kathmandu" },
    { value: "23", label: "(GMT+06:00) Astana, Dhaka" },
    { value: "83", label: "(GMT+06:00) Novosibirsk, Omsk" },
    { value: "84", label: "(GMT+06:30) Yangon (Rangoon)" },
    { value: "25", label: "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
    { value: "85", label: "(GMT+07:00) Krasnoyarsk" },
    { value: "26", label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi" },
    { value: "86", label: "(GMT+08:00) Irkutsk" },
    { value: "28", label: "(GMT+08:00) Kuala Lumpur, Singapore" },
    { value: "27", label: "(GMT+08:00) Perth" },
    { value: "29", label: "(GMT+08:00) Taipei" },
    { value: "90", label: "(GMT+08:00) Ulaan Bataar" },
    { value: "91", label: "(GMT+08:30) Pyongyang" },
    { value: "30", label: "(GMT+09:00) Osaka, Sapporo, Tokyo" },
    { value: "31", label: "(GMT+09:00) Seoul" },
    { value: "32", label: "(GMT+09:00) Yakutsk" },
    { value: "33", label: "(GMT+09:30) Adelaide" },
    { value: "34", label: "(GMT+09:30) Darwin" },
    { value: "35", label: "(GMT+10:00) Brisbane" },
    { value: "36", label: "(GMT+10:00) Canberra, Melbourne, Sydney" },
    { value: "37", label: "(GMT+10:00) Guam, Port Moresby" },
    { value: "38", label: "(GMT+10:00) Hobart" },
    { value: "39", label: "(GMT+10:00) Vladivostok" },
    { value: "76", label: "(GMT+11:00) Magadan" },
    { value: "40", label: "(GMT+11:00) Solomon Is., New Caledonia" },
    { value: "41", label: "(GMT+12:00) Auckland, Wellington" },
    { value: "42", label: "(GMT+12:00) Fiji, Marshall Is." },
    { value: "77", label: "(GMT+12:00) Kamchatka" },
    { value: "87", label: "(GMT+13:00) Nuku'alofa" }
  ];
  export const hunt_group_call_dist_user_ring_out_time = [
    { value: 5, label: '5 Seconds' },
    { value: 10, label: '10 Seconds' },
    { value: 15, label: '15 Seconds' },
    { value: 20, label: '20 Seconds' }
  ];

  export const mailID = {
    email: 'democcaas@worktual.com'
  }


  export const branchOpt = [
    {
        "label": "Adyar",
        "value": "ADY"
    },
    {
        "label": "Adyar (Gandhi Nagar)",
        "value": "AGN"
    },
    {
        "label": "Ahmedabad",
        "value": "AHM"
    },
    {
        "label": "Adajan Road, Surat",
        "value": "AJR"
    },
    {
        "label": "Akhnoor, Jammu",
        "value": "AKR"
    },
    {
        "label": "Ambattur",
        "value": "AMB"
    },
    {
        "label": "Port Blair",
        "value": "AMN"
    },
    {
        "label": "Anna Nagar",
        "value": "ANN"
    },
    {
        "label": "Arapalayam",
        "value": "APM"
    },
    {
        "label": "Annapurna",
        "value": "APR"
    },
    {
        "label": "Kodambakkam",
        "value": "ASN"
    },
    {
        "label": "AS Rao Nagar",
        "value": "ASR"
    },
    {
        "label": "Ashta",
        "value": "ATA"
    },
    {
        "label": "Avadi",
        "value": "AVD"
    },
    {
        "label": "Bellary",
        "value": "BAY"
    },
    {
        "label": "Bhandup",
        "value": "BDP"
    },
    {
        "label": "Belgaum &#8211; East",
        "value": "BGE"
    },
    {
        "label": "Belgaum",
        "value": "BGM"
    },
    {
        "label": "Bhubaneswar",
        "value": "BHU"
    },
    {
        "label": "Barnala",
        "value": "BLA"
    },
    {
        "label": "Bannerghatta Road",
        "value": "BMH"
    },
    {
        "label": "Bandra - CEDS",
        "value": "BNA"
    },
    {
        "label": "Bhavnagar",
        "value": "BNR"
    },
    {
        "label": "Badlapur &#8211; West",
        "value": "BPW"
    },
    {
        "label": "Beira",
        "value": "BRA"
    },
    {
        "label": "Banashankari",
        "value": "BSK"
    },
    {
        "label": "Borivali",
        "value": "BVL"
    },
    {
        "label": "Krushi Nagar",
        "value": "CGR"
    },
    {
        "label": "Coles Road",
        "value": "CLR"
    },
    {
        "label": "kozhikode, Mavoor Road",
        "value": "CLT"
    },
    {
        "label": "RS Puram",
        "value": "CMB"
    },
    {
        "label": "Cochin, MG Road",
        "value": "CMD"
    },
    {
        "label": "TTK Road - Center of Excellence",
        "value": "CMH"
    },
    {
        "label": "Chromepet",
        "value": "CMP"
    },
    {
        "label": "Chembur",
        "value": "CMR"
    },
    {
        "label": "Coonoor",
        "value": "CNR"
    },
    {
        "label": "Chowpatty",
        "value": "CPY"
    },
    {
        "label": "Cuttack",
        "value": "CTK"
    },
    {
        "label": "Dharmapuri",
        "value": "DHA"
    },
    {
        "label": "Dilsukhnagar",
        "value": "DNR"
    },
    {
        "label": "Davanagere, Karnataka",
        "value": "DVG"
    },
    {
        "label": "Dharwad",
        "value": "DWD"
    },
    {
        "label": "Ebene",
        "value": "EBN"
    },
    {
        "label": "Electronic City",
        "value": "ECY"
    },
    {
        "label": "Egmore",
        "value": "EGM"
    },
    {
        "label": "Erode",
        "value": "ERD"
    },
    {
        "label": "Gachibowli",
        "value": "GCB"
    },
    {
        "label": "Accra",
        "value": "GHA"
    },
    {
        "label": "Gadhinglaj",
        "value": "GLJ"
    },
    {
        "label": "Guntur",
        "value": "GUN"
    },
    {
        "label": "Hadapsar",
        "value": "HDP"
    },
    {
        "label": "Himayat Nagar",
        "value": "HIM"
    },
    {
        "label": "Panjagutta",
        "value": "HMH"
    },
    {
        "label": "Hosur",
        "value": "HSR"
    },
    {
        "label": "Hubli",
        "value": "HUB"
    },
    {
        "label": "Indiranagar - Refractive (Lasik & SMILE) & Dry Eye Hub",
        "value": "INR"
    },
    {
        "label": "Trikuta nagar, Jammu, Sood Eye Care Centre",
        "value": "JMU"
    },
    {
        "label": "Janipur, Jammu",
        "value": "JNR"
    },
    {
        "label": "Jaipur",
        "value": "JPR"
    },
    {
        "label": "Indore Old Palasia",
        "value": "JWS"
    },
    {
        "label": "Kasba",
        "value": "KAS"
    },
    {
        "label": "Kumbakonam",
        "value": "KBK"
    },
    {
        "label": "Kabulonga",
        "value": "KBU"
    },
    {
        "label": "Kallakurichi",
        "value": "KCH"
    },
    {
        "label": "Kukatpally",
        "value": "KKY"
    },
    {
        "label": "Kalyan",
        "value": "KLN"
    },
    {
        "label": "Koramangala",
        "value": "KML"
    },
    {
        "label": "kakinada",
        "value": "KND"
    },
    {
        "label": "Kanchipuram",
        "value": "KNP"
    },
    {
        "label": "Peerless",
        "value": "KOL"
    },
    {
        "label": "Karimnagar",
        "value": "KRM"
    },
    {
        "label": "Karur",
        "value": "KRR"
    },
    {
        "label": "Krishnagiri",
        "value": "KSN"
    },
    {
        "label": "Kothrud",
        "value": "KTD"
    },
    {
        "label": "Kottayam",
        "value": "KTM"
    },
    {
        "label": "Kovilpatti",
        "value": "KVP"
    },
    {
        "label": "Kitwe",
        "value": "KWE"
    },
    {
        "label": "Ramanathapuram",
        "value": "LMS"
    },
    {
        "label": "Mombasa",
        "value": "MBA"
    },
    {
        "label": "Goods Shed Street, Madurai",
        "value": "MCB"
    },
    {
        "label": "Sayyaji Rao Road",
        "value": "MCC"
    },
    {
        "label": "Madeenaguda",
        "value": "MDA"
    },
    {
        "label": "Swastik Vihar",
        "value": "MDC"
    },
    {
        "label": "Anatananarivo",
        "value": "MDR"
    },
    {
        "label": "KK Nagar",
        "value": "MDU"
    },
    {
        "label": "Mogappair West",
        "value": "MGP"
    },
    {
        "label": "Jayalakshmipuram",
        "value": "MJP"
    },
    {
        "label": "Sector 61, Mohali",
        "value": "MLI"
    },
    {
        "label": "Wadala",
        "value": "MMH"
    },
    {
        "label": "Madanapalle",
        "value": "MPE"
    },
    {
        "label": "Mehdipatnam",
        "value": "MPM"
    },
    {
        "label": "Madhapur",
        "value": "MPR"
    },
    {
        "label": "Mulund (East)",
        "value": "MUE"
    },
    {
        "label": "Mulund (West)",
        "value": "MUW"
    },
    {
        "label": "Mwanza",
        "value": "MWA"
    },
    {
        "label": "Kuvempunagara",
        "value": "MYS"
    },
    {
        "label": "Maputo",
        "value": "MZQ"
    },
    {
        "label": "Nairobi",
        "value": "NAB"
    },
    {
        "label": "Nagercoil",
        "value": "NCL"
    },
    {
        "label": "Nellore",
        "value": "NEL"
    },
    {
        "label": "Namakkal",
        "value": "NKL"
    },
    {
        "label": "Nakkal Road",
        "value": "NKR"
    },
    {
        "label": "Ndola",
        "value": "NLA"
    },
    {
        "label": "Nanganallur",
        "value": "NLR"
    },
    {
        "label": "Satpur Colony",
        "value": "NMH"
    },
    {
        "label": "Tondiarpet",
        "value": "NWP"
    },
    {
        "label": "Nizamabad",
        "value": "NZB"
    },
    {
        "label": "One Town Road",
        "value": "OTR"
    },
    {
        "label": "Pimpri-Chinchwad",
        "value": "PCH"
    },
    {
        "label": "Pudukkottai",
        "value": "PDK"
    },
    {
        "label": "Puducherry",
        "value": "PDY"
    },
    {
        "label": "Pragathinagar",
        "value": "PGN"
    },
    {
        "label": "Sector 15, Panchkula",
        "value": "PLA"
    },
    {
        "label": "Perambur",
        "value": "PMB"
    },
    {
        "label": "Sector 22A, Chandigarh",
        "value": "PMH"
    },
    {
        "label": "Peer-Muchala/ Dhakoli",
        "value": "PML"
    },
    {
        "label": "Padmanabhanagar",
        "value": "PNR"
    },
    {
        "label": "Porur",
        "value": "PRR"
    },
    {
        "label": "Aundh",
        "value": "PUN"
    },
    {
        "label": "Rajahmundry",
        "value": "RAJ"
    },
    {
        "label": "Rajajinagar (Retina Centre - VR Surgery)",
        "value": "RJN"
    },
    {
        "label": "Rajkot",
        "value": "RJT"
    },
    {
        "label": "Raikot",
        "value": "RKT"
    },
    {
        "label": "RR Nagar",
        "value": "RRN"
    },
    {
        "label": "RS Pura, Jammu",
        "value": "RSP"
    },
    {
        "label": "Kigali",
        "value": "RWD"
    },
    {
        "label": "Secunderabad",
        "value": "SBD"
    },
    {
        "label": "Srirangam",
        "value": "SGM"
    },
    {
        "label": "Salt Lake",
        "value": "SLK"
    },
    {
        "label": "Salem",
        "value": "SLM"
    },
    {
        "label": "Sholinganallur",
        "value": "SLR"
    },
    {
        "label": "Ring Road, Surat",
        "value": "SMH"
    },
    {
        "label": "Srinagar, kashmir",
        "value": "SNA"
    },
    {
        "label": "Sangvi",
        "value": "SNG"
    },
    {
        "label": "Santhosh Nagar",
        "value": "SNR"
    },
    {
        "label": "Siddipet",
        "value": "SPT"
    },
    {
        "label": "Satara",
        "value": "STR"
    },
    {
        "label": "Shivaji Nagar",
        "value": "SVR"
    },
    {
        "label": "Tambaram",
        "value": "TBM"
    },
    {
        "label": "Tuticorin",
        "value": "TCN"
    },
    {
        "label": "Thane",
        "value": "THA"
    },
    {
        "label": "Tumkur",
        "value": "TKR"
    },
    {
        "label": "Tiruvallur",
        "value": "TLR"
    },
    {
        "label": "Thanjavur",
        "value": "TNJ"
    },
    {
        "label": "Tiruvannamalai",
        "value": "TNM"
    },
    {
        "label": "Tiruppur",
        "value": "TPR"
    },
    {
        "label": "Tirupati",
        "value": "TPT"
    },
    {
        "label": "Triplicane",
        "value": "TRC"
    },
    {
        "label": "Trichy",
        "value": "TRI"
    },
    {
        "label": "Tardeo",
        "value": "TSM"
    },
    {
        "label": "Tirunelveli",
        "value": "TVL"
    },
    {
        "label": "Thiruvananthapuram",
        "value": "TVM"
    },
    {
        "label": "Thiruvottiyur",
        "value": "TVT"
    },
    {
        "label": "Dar Es Salaam",
        "value": "TZA"
    },
    {
        "label": "Udhana",
        "value": "UDN"
    },
    {
        "label": "Kampala",
        "value": "UGD"
    },
    {
        "label": "Uppal",
        "value": "UPL"
    },
    {
        "label": "Vesu, Surat",
        "value": "VES"
    },
    {
        "label": "Vikhroli",
        "value": "VIK"
    },
    {
        "label": "Virar",
        "value": "VIR"
    },
    {
        "label": "Velachery",
        "value": "VLC"
    },
    {
        "label": "Virudhachalam",
        "value": "VLM"
    },
    {
        "label": "Vellore",
        "value": "VLR"
    },
    {
        "label": "Varanasi",
        "value": "VMB"
    },
    {
        "label": "Visakhapatnam",
        "value": "VMH"
    },
    {
        "label": "Governerpet, Vijayawada",
        "value": "VMR"
    },
    {
        "label": "Viman Nagar",
        "value": "VNR"
    },
    {
        "label": "Vapi",
        "value": "VPI"
    },
    {
        "label": "Villupuram",
        "value": "VPM"
    },
    {
        "label": "Vashi",
        "value": "VSH"
    },
    {
        "label": "Vashi, Sector-12",
        "value": "VSI"
    },
    {
        "label": "Vishrantwadi",
        "value": "VWD"
    },
    {
        "label": "Whitefield",
        "value": "WFD"
    },
    {
        "label": "Warangal",
        "value": "WRL"
    },
    {
        "label": "Yelahanka",
        "value": "YLK"
    },
    {
        "label": "Lusaka (Main Branch)",
        "value": "ZMB"
    },
    {
        "label": "Vanasthalipuram",
        "value": "vns"
    }
];

export const calvaryComp_Id = 19799;
export const only_chatbot = 19562;

export const STRIPE_LIVE_PK_KEY ="pk_live_51OufalK7fs8cZPqEWKmar4jDkGPchKNQW25gEbGQbTBpuHzGRVuyM5Xkx1PqBp0DZvF3I7nu0o0fohYvzCFVymFz00a9x8RHi9";
export const STRIPE_TEST_PK_KEY= "pk_test_51OufalK7fs8cZPqEdd4WzD0jMkRBnGhxny6lrDDF7qrajqjZok2jO7XJoEWSDayjcS4TkIjX61fsLYiEzsynWJjq00R70g0VM5";